  import { defineComponent, type PropType } from "vue";
  import ContratEditBaseSalarie from '@/extend/controls/contrat/ContratEditBaseSalarie';
  import ContratExoEtranger from '@/extend/controls/contrat/ContratExoEtranger';
  import ContratTemplateSelect from '@/extend/controls/contratTemplate/ContratTemplateSelect';
  import ConventionClauseMiroir from '@/extend/controls/convention/ConventionClauseMiroir';
  import EmploiSelect from '@/extend/controls/emploi/EmploiSelect';
  import RubriqueSelect from '@/extend/controls/rubrique/RubriqueSelect';
  import SalarieSummary from '@/extend/controls/salarie/SalarieSummary';
  import Contrat from '@/extend/classes/Contrat';
  import { FieldStatus, EditFieldTheme, SectionStatus } from '@/framework/base/components/FieldInfo';
  import { Alerts } from '@/framework/base/helpers/Alerts'; 
  import { storeContrat } from '@/generated/stores';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import { Extended } from '@/framework/base/classes/Schema';
  import ButtonPlus from '@/framework/base/components/ButtonPlus.vue';
  import Route from '@/generated/classes/Route';
  import { Fiches, Sections } from '@/generated/classes/AppSchema';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  import GraphControl from '@/framework/graph/components/GraphControl.vue';
  import { GraphAnswer, GraphMinimum } from '@/generated/classes/GraphData';
  export default defineComponent({
    components: {
      SectionHeader,
      LoaderButton,
      ButtonPlus,
      GraphControl,
      ContratEditBaseSalarie,
      ContratExoEtranger,
      ContratTemplateSelect,
      ConventionClauseMiroir,
      EmploiSelect,
      RubriqueSelect,
      SalarieSummary,
    },

    props: {
      contrat: {
        type: Object as PropType<Contrat>,
        required: true
      },
      showButton: {
        type: Boolean,
      },
      autoSave: {
        type: Boolean,
      },
      fieldOnly: {
        type: Boolean,
      },
      extended: {
        type: Boolean,
      },
      autoClear: {
        type: Boolean,
      },
      dialog: {
        type: Boolean,
      },
      closeSection: {
        type: Boolean,
      },
      showMissing: {
        type: Boolean,
      },
      moduleId: {
        type: Number,
      },
      theme: {
        type: Object as PropType<EditFieldTheme>,
      },
      fiche: {
        type: String,
      },
      fromSection: {
        type: String,
      },
      requiredAttributs: {
        type: Array as PropType<string[]>,
      },
      toggleResetContratTemplateSelect: {
        type: Boolean
      },
      toggleResetConventionClauseMiroir: {
        type: Boolean
      },
      toggleResetEmploiSelect: {
        type: Boolean
      },
      toggleResetRubriqueSelect: {
        type: Boolean
      },
    },

    beforeUnmount (): void {
      if (!this.closeSection) {
        this.beforeClose();
      }
    },

    data() {
      return {
        graphStatus: new FieldStatus(false, false, 0),
        editBaseSalarieStatus: new FieldStatus(false, false, 0),
        strEditBaseSalarie: '',
        exoEtrangerStatus: new FieldStatus(false, false, 0),
        strExoEtranger: '',
    toggleContratTemplateId: false,
        contratTemplateIdStatus: new FieldStatus(false, false, 0),
        strContratTemplateId: '',
    toggleConventionAppliqueeId: false,
        conventionAppliqueeIdStatus: new FieldStatus(false, false, 0),
        strConventionAppliqueeId: '',
    toggleEmploiId: false,
        emploiIdStatus: new FieldStatus(false, false, 0),
        strEmploiId: '',
    toggleId: false,
        rubriqueSelectStatus: new FieldStatus(false, false, 0),
    toggleSalarieId: false,
        salarieIdStatus: new FieldStatus(false, false, 0),
        strSalarieId: '',
        toggleGraph: false,
        refContrat: new Contrat,
        cloneContrat: new Contrat,
      contratSaving: false,
        saving: false,
        restoring: false,
        inDialog: false,
        updated: false,
        error: false,
        saveLoading: false,
        saveFailed: false,
        allowClearRef: true,
        objType: ObjTypes.CONTRAT,
        status: new SectionStatus(false, false, false),
        autoClose: true,
        closing: false
      }
    },
    computed: {
      isExtended (): boolean {
        return this.extended;
      },

      exist (): boolean {
        return this.editContrat.id != 0
      },

      extendIcon (): string {
        return this.extended ? 'fas fa-circle-minus' : 'fas fa-circle-plus';
      },

      saveButton (): boolean {
        return (this.showButton == undefined || this.showButton == true) && !this.allReadOnly;
      },

      editContrat: {
        get(): Contrat {
          if (this.closeSection) {
            this.beforeClose();
          } else {
            if (this.contrat != undefined) {
              if (this.contrat.id == 0) {
                Alerts.debug('CrudContrat : les objets passés en paramètre doivent être issus du store (id <> 0)');
              }
              if (this.cloneContrat.id != this.contrat.id && !this.saving) {
                this.handleContratChange();
              }
            }
          }
          return this.refContrat;
        },
        set(value: Contrat) {
          this.refContrat = value;
        }
      },

      canCreate (): boolean {
        return this.refContrat.id > 0;
      },

      canDelete (): boolean {
        return this.refContrat.canDelete && this.refContrat.id > 0;
      },

      updatedAndValid (): boolean {
        return this.updated && !this.error;
      },
      graphAnswers: {
        get(): GraphAnswer[] {
          return this.editContrat.graphAnswers;
        },
        set(value: GraphAnswer[]) {
          this.editContrat.graphAnswers = value;
        }
      },

      clearAuto (): boolean {
        return (this.autoClear == undefined || this.autoClear == true) && this.allowClearRef;
      },


      editBaseSalarie: {
        get(): string {
          return this.strEditBaseSalarie;
        },
        set(value: string) {
          const editBaseSalarie = parseFloat(value);
          if (editBaseSalarie.toString() == value) {
            this.editContrat.editBaseSalarie = editBaseSalarie;
            this.fieldUpdated('EDIT_BASE_SALARIE', value);
          }
          this.strEditBaseSalarie = value;
        }
      },


      exoEtranger: {
        get(): boolean | null {
          return this.editContrat.exoEtranger;
        },
        set(value: boolean | null) {
          this.editContrat.exoEtranger = value;
          this.fieldUpdated('EXO_ETRANGER', value);
        }
      },

    resetContratTemplateId (): boolean {
      return this.toggleContratTemplateId
    },

      contratTemplateId: {
        get(): number {
          return this.editContrat.contratTemplateId;
        },
        set(value: number) {
          this.editContrat.contratTemplateId = value;
          this.fieldUpdated('CONTRAT_TEMPLATE_ID', value);
        }
      },

    resetConventionAppliqueeId (): boolean {
      return this.toggleConventionAppliqueeId
    },

      conventionAppliqueeId: {
        get(): number {
          return this.editContrat.conventionAppliqueeId;
        },
        set(value: number) {
          this.editContrat.conventionAppliqueeId = value;
          this.fieldUpdated('CONVENTION_APPLIQUEE_ID', value);
        }
      },

    resetEmploiId (): boolean {
      return this.toggleEmploiId
    },

      emploiId: {
        get(): number {
          return this.editContrat.emploiId;
        },
        set(value: number) {
          this.editContrat.emploiId = value;
          this.fieldUpdated('EMPLOI_ID', value);
        }
      },

    resetId (): boolean {
      return this.toggleId
    },
    resetSalarieId (): boolean {
      return this.toggleSalarieId
    },

      salarieId: {
        get(): number {
          return this.editContrat.salarieId;
        },
        set(value: number) {
          this.editContrat.salarieId = value;
          this.fieldUpdated('SALARIE_ID', value);
        }
      },


      allReadOnly (): boolean {
        const res = this.contrat.canUpdate && (
        (this.isDisplayed('EDIT_BASE_SALARIE') && !this.readOnly('EDIT_BASE_SALARIE')) ||
        (this.isDisplayed('EXO_ETRANGER') && !this.readOnly('EXO_ETRANGER')) ||
        (this.isDisplayed('CONTRAT_TEMPLATE_ID') && !this.readOnly('CONTRAT_TEMPLATE_ID')) ||
        (this.isDisplayed('CONVENTION_APPLIQUEE_ID') && !this.readOnly('CONVENTION_APPLIQUEE_ID')) ||
        (this.isDisplayed('EMPLOI_ID') && !this.readOnly('EMPLOI_ID')) ||
        (this.isDisplayed('RUBRIQUE_SELECT') && !this.readOnly('RUBRIQUE_SELECT')) ||
        (this.isDisplayed('SALARIE_ID') && !this.readOnly('SALARIE_ID')) ||
        (this.isDisplayed('GRAPH_CONTROL') && !this.readOnly('GRAPH_CONTROL')));
        return !res;
      },

      fields (): string[] {
        return ['EDIT_BASE_SALARIE', 'EXO_ETRANGER', 'CONTRAT_TEMPLATE_ID', 'CONVENTION_APPLIQUEE_ID', 'EMPLOI_ID', 'RUBRIQUE_SELECT', 'SALARIE_ID'];
      },
    },

    methods: {
      handleContratChange() : void {
        // Edited object changed
        this.saveFailed = false;
        this.toggleGraph = !this.toggleGraph;
        if (this.autoSave && this.updatedAndValid) {
          if (!this.inDialog && this.checkFields()) {
            // Dialogue to save or cancel changes
            this.inDialog = true;
            this.dialogSaveOrCancel().then(() => {
              this.createRef(this.contrat);
              this.inDialog = false;
                  })
          } else if (!this.restoring && !this.inDialog) {
            this.restoreEdited();
            this.createRef(this.contrat);
          }
        } else if (!this.inDialog) {
          if (this.cloneContrat.id < 0) {
            this.clearRef();
          } else if (this.updated) {
            this.restoreEdited();
          }
          this.createRef(this.contrat);
        }
      },
      beforeClose (): void {
        if (!this.closing) {
          this.closing = true;
          if (this.autoSave && this.updatedAndValid && this.checkFields()) {
            this.$emit('saveOrCancel');
            this.dialogSaveOrCancel();
          } else {
            if (this.autoSave && this.updated) {
              this.restoreEdited();
            }
            this.$emit('cancelled');
          }
          this.clearRef();
          }
      },

      setExtended (extended: Extended): void {
         this.$emit('extended', extended);
      },

      // eslint-disable-next-line
      isDisplayed (value: string): boolean {
        return true;
      },

      // eslint-disable-next-line
      required (value: string): boolean {
        return false;
      },

      // eslint-disable-next-line
      readOnly (value: string): boolean {
        return false;
      },

      save (): void {
        if (event != undefined) {
          event.stopPropagation();
        }
        this.saveLoading = true;
        this.saveFailed = false;
        if (this.checkFields()) {
          this.saveObj();
        } else {
        this.saveLoading = false;
          this.saveFailed = true;
        }
      },

      setUpdated (): void {
        const updated = (this.editBaseSalarieStatus != undefined && this.editBaseSalarieStatus.updated) ||
          (this.exoEtrangerStatus != undefined && this.exoEtrangerStatus.updated) ||
          (this.contratTemplateIdStatus != undefined && this.contratTemplateIdStatus.updated) ||
          (this.conventionAppliqueeIdStatus != undefined && this.conventionAppliqueeIdStatus.updated) ||
          (this.emploiIdStatus != undefined && this.emploiIdStatus.updated) ||
          (this.rubriqueSelectStatus != undefined && this.rubriqueSelectStatus.updated) ||
          (this.salarieIdStatus != undefined && this.salarieIdStatus.updated) ||
          (this.graphStatus != undefined && this.graphStatus.updated);
        if (updated != this.updated) {
          this.updated = updated;
          this.status.updated = updated;
          this.status.missing = this.hasMissing();
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.contrat);
        }
      },

      setError (): void {
        const error = this.editBaseSalarieStatus.error ||
        this.exoEtrangerStatus.error ||
        this.contratTemplateIdStatus.error ||
        this.conventionAppliqueeIdStatus.error ||
        this.emploiIdStatus.error ||
        this.rubriqueSelectStatus.error ||
        this.salarieIdStatus.error ||
          this.graphStatus.error;
        if (error != this.error) {
          if (!error) {
            this.saveFailed = false;
          }
          this.error = error;
          this.status.error = error;
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.contrat);
        }
      },

      setMinimum(value: GraphMinimum): void {
        this.editContrat.graphMinimum = value;
      },

      statusGraph(value: FieldStatus): void {
        this.graphStatus = value;
        this.setUpdated();
        this.setError();
      },

      // Clear non saved new objects when leaving
      clearRef (): void {
        if (this.clearAuto && this.refContrat.id < 0) {
          storeContrat.mContratDeleted(this.refContrat.id);
        }
      },

      // Dialog to save or ignore changes when loosing focus or changing edited item
      dialogSaveOrCancel (): Promise<boolean> {
        return new Promise((resolve) => {
          if (!this.error) {
            Alerts.saveOrCancel()
              .then((result: boolean) => {
                if (result) {
                  this.saveObj();
                } else {
                  if (this.refContrat.id <= 0) {
                    this.deleteObj();
                  } else {
                    this.restoreEdited();
                  }
                  this.$emit('cancelled');
                }
                resolve(result);
              })
          } else {
            this.restoreEdited();
          }
        })
      },

      // Save object and subobjects referenced by foreignClass keys
      saveObj (): void {
        this.saving = true;
        if (
          this.saveContrat()
          ) {
          this.toggleGraph = !this.toggleGraph;
          this.saving = false;
          this.saveLoading = false;
          this.contratSaving = false;
          this.createRef(this.refContrat);
          this.$emit('updated', this.refContrat);
          if (this.contrat.id > 0) {
            this.$emit('saved', this.refContrat);
          } else {
            this.updated = true;
          }
          if (this.autoClose) {
            this.saveFields();
            this.$emit('closeDialog');
          }
        } else {
          if (this.refContrat.failed) {
          this.saveLoading = false;
            this.contratSaving = false;
            this.refContrat.failed = false;
          }
        }
      },

      saveContrat (): boolean {
        if (!this.refContrat.compareContrat(this.cloneContrat)) {
          if (!this.contratSaving) {
            this.contratSaving = true;
          if (this.refContrat.id > 0) {
            storeContrat.updateContrat(this.refContrat)
              .then((data: Contrat) => {
                if (!data.failed) {
                  this.refContrat = storeContrat.getContrat(data.id);
                  this.cloneContrat = data.cloneContrat();
                } else {
                  this.refContrat.failed = true;
                }
                this.saveObj();
              })
              .catch(() => {
                this.restoreEdited();
                this.contratSaving = false;
                this.saveLoading = false;
              })
          }
            if (this.refContrat.id <= 0) {
              storeContrat.createContrat(this.refContrat)
                .then((data: Contrat) => {
                  if (!data.failed) {
                    this.refContrat = storeContrat.getContrat(data.id);
                    this.cloneContrat = data.cloneContrat();
                  } else {
                this.refContrat.failed = true;
                  }
                  this.saveObj();
                })
                .catch(() => {
                  this.restoreEdited();
                    this.contratSaving = false;
                })
            }
          }
          return false;
        } else {
          return true;
        }
      },

      // Delete object
      deleteObj (): void {
        if (this.refContrat.id <= 0) {
          storeContrat.mContratDeleted(this.refContrat.id);
        } else {
          storeContrat.deleteContrat(this.refContrat);
        }
      },

      statusEditBaseSalarie (value: FieldStatus): void {
        this.editBaseSalarieStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusExoEtranger (value: FieldStatus): void {
        this.exoEtrangerStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusContratTemplateId (value: FieldStatus): void {
        this.contratTemplateIdStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusConventionAppliqueeId (value: FieldStatus): void {
        this.conventionAppliqueeIdStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusEmploiId (value: FieldStatus): void {
        this.emploiIdStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusRubriqueSelect (value: FieldStatus): void {
        this.rubriqueSelectStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusSalarieId (value: FieldStatus): void {
        this.salarieIdStatus = value;
        this.setUpdated();
        this.setError();
      },

      deleteContrat(): void {
        this.$emit('deleteContrat',  this.contrat);
      },

    addContrat(): void {
      this.$emit('addContrat',  this.contrat);
    },

      // Restore object
      restoreEdited (): void {
        if (this.cloneContrat != undefined) {
          this.restoring = true;
          this.refContrat.editBaseSalarie = this.cloneContrat.editBaseSalarie;
          this.refContrat.exoEtranger = this.cloneContrat.exoEtranger;
          this.refContrat.contratTemplateId = this.cloneContrat.contratTemplateId;
          this.refContrat.conventionAppliqueeId = this.cloneContrat.conventionAppliqueeId;
          this.refContrat.emploiId = this.cloneContrat.emploiId;
          this.restoring = false;
        }
      },


    // Clone and clear edited
      createRef (value: Contrat): void {
        this.clearRef();
        this.editContrat = value;
        this.cloneContrat = value.cloneContrat();
        this.editBaseSalarieStatus.clear(value.id);
        this.exoEtrangerStatus.clear(value.id);
        this.contratTemplateIdStatus.clear(value.id);
        this.conventionAppliqueeIdStatus.clear(value.id);
        this.emploiIdStatus.clear(value.id);
        this.rubriqueSelectStatus.clear(value.id);
        this.salarieIdStatus.clear(value.id);
        this.graphStatus.clear(value.id);
        this.status.clear();
        this.strEditBaseSalarie = this.editContrat.editBaseSalarie.toString();
      },

    checkFields (): boolean {
        // @ts-expect-error : generated method
        if (this.isDisplayed('EDIT_BASE_SALARIE') && this.$refs.EDIT_BASE_SALARIE) this.$refs.EDIT_BASE_SALARIE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('EXO_ETRANGER') && this.$refs.EXO_ETRANGER) this.$refs.EXO_ETRANGER.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('CONTRAT_TEMPLATE_ID') && this.$refs.CONTRAT_TEMPLATE_ID) this.$refs.CONTRAT_TEMPLATE_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('CONVENTION_APPLIQUEE_ID') && this.$refs.CONVENTION_APPLIQUEE_ID) this.$refs.CONVENTION_APPLIQUEE_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('EMPLOI_ID') && this.$refs.EMPLOI_ID) this.$refs.EMPLOI_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('RUBRIQUE_SELECT') && this.$refs.RUBRIQUE_SELECT) this.$refs.RUBRIQUE_SELECT.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('SALARIE_ID') && this.$refs.SALARIE_ID) this.$refs.SALARIE_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('GRAPH_CONTROL') && this.$refs.GRAPH_CONTROL) this.$refs.GRAPH_CONTROL.touch();
        return !this.error;
      },

      missing (value: string): boolean {
        return this.hasMissing(value);
      },

      hasMissing (value = ''): boolean {
        let missing = false;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'EDIT_BASE_SALARIE') && this.isDisplayed('EDIT_BASE_SALARIE') && this.$refs.EDIT_BASE_SALARIE && this.$refs.EDIT_BASE_SALARIE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'EXO_ETRANGER') && this.isDisplayed('EXO_ETRANGER') && this.$refs.EXO_ETRANGER && this.$refs.EXO_ETRANGER.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'CONTRAT_TEMPLATE_ID') && this.isDisplayed('CONTRAT_TEMPLATE_ID') && this.$refs.CONTRAT_TEMPLATE_ID && this.$refs.CONTRAT_TEMPLATE_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'CONVENTION_APPLIQUEE_ID') && this.isDisplayed('CONVENTION_APPLIQUEE_ID') && this.$refs.CONVENTION_APPLIQUEE_ID && this.$refs.CONVENTION_APPLIQUEE_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'EMPLOI_ID') && this.isDisplayed('EMPLOI_ID') && this.$refs.EMPLOI_ID && this.$refs.EMPLOI_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'RUBRIQUE_SELECT') && this.isDisplayed('RUBRIQUE_SELECT') && this.$refs.RUBRIQUE_SELECT && this.$refs.RUBRIQUE_SELECT.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'SALARIE_ID') && this.isDisplayed('SALARIE_ID') && this.$refs.SALARIE_ID && this.$refs.SALARIE_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'GRAPH_CONTROL') && this.isDisplayed('GRAPH_CONTROL') && this.$refs.GRAPH_CONTROL && this.$refs.GRAPH_CONTROL.missing()) missing = true;
        return missing;
      },

      saveFields (): void {
        // @ts-expect-error : generated method
        if (this.isDisplayed('EDIT_BASE_SALARIE') && this.$refs.EDIT_BASE_SALARIE) this.$refs.EDIT_BASE_SALARIE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('EXO_ETRANGER') && this.$refs.EXO_ETRANGER) this.$refs.EXO_ETRANGER.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('CONTRAT_TEMPLATE_ID') && this.$refs.CONTRAT_TEMPLATE_ID) this.$refs.CONTRAT_TEMPLATE_ID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('CONVENTION_APPLIQUEE_ID') && this.$refs.CONVENTION_APPLIQUEE_ID) this.$refs.CONVENTION_APPLIQUEE_ID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('EMPLOI_ID') && this.$refs.EMPLOI_ID) this.$refs.EMPLOI_ID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('RUBRIQUE_SELECT') && this.$refs.RUBRIQUE_SELECT) this.$refs.RUBRIQUE_SELECT.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('SALARIE_ID') && this.$refs.SALARIE_ID) this.$refs.SALARIE_ID.save();
      },

      getValue (field: string): string {
         if (field == 'EDIT_BASE_SALARIE') return this.editBaseSalarie.toString();
        else  if (field == 'EXO_ETRANGER') return this.exoEtranger == null ? '' : this.exoEtranger.toString();
        else  if (field == 'CONTRAT_TEMPLATE_ID') return this.contratTemplateId.toString();
        else  if (field == 'CONVENTION_APPLIQUEE_ID') return this.conventionAppliqueeId.toString();
        else  if (field == 'EMPLOI_ID') return this.emploiId.toString();
        else  if (field == 'SALARIE_ID') return this.salarieId.toString();
        else return '';
      },

    // eslint-disable-next-line
    fieldUpdated (field: string, value: unknown): void {
      // To implement
    },

      setFocus (route: Route): boolean {
        let res = false;
        let first = '';
        const attribut = route ? route.attribut : '';
        this.fields.forEach(field => {
          // @ts-expect-error : generated method
          if (!res && this.isDisplayed(field) && !this.readOnly(field) && this.$refs[field].setFocus) {
            if (attribut == field) {
              // @ts-expect-error : generated method
              this.$refs[attribut].setFocus();
              res = true;
            } else if (first == '') {
              first = field;
            }
          }
        })
        // @ts-expect-error : generated method
        if (!res && first != '' && this.$refs[first] && this.$refs[first].setFocus) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus();
          res = true;
        }
        return res
      },

      closeDialog(): void {
        this.$emit('closeDialog')
      }
    },
  })
